import axios from 'axios';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { GROLOG_BASE_URL } from '../../constant/apiConstant';
import { setStatusInvitation } from "../../store/reducer/page.reducer";

const LoginCompletionSuccess = () => {
  const [searchParams] = useSearchParams()
  const invitationCode = searchParams.get("invitation_code")
  const [message,setMessage] = useState(false)
  const dispatch = useDispatch();

  const doPost = async (endpoint, tkn, data, dispatch, refresh_token) => {
    const url = GROLOG_BASE_URL + endpoint;
    const method = "POST";
    const headers = { Authorization: tkn };
    const request = { url, method,headers,data, };
    return axios(request);
  };
  
  const onSubmit=async()=>{
    let datas={
      "status_invitation":"O",
      "invitation_code":invitationCode
  }
    try{
      let res = await doPost(`/auth/update-status-invitation`,  'TOKEN@TEST2023', datas);
      // message.success(_.startCase("success completion"));
      setMessage(true)
        const timer = setTimeout(() => {
          window.close();
        }, 2000);
    
        return () => clearTimeout(timer);
      // navigate(ROUTES.INDEX)
   
    }catch(err){
        const timer = setTimeout(() => {
          window.close();
        }, 2000);
    
        return () => clearTimeout(timer);
      
    }
  }
  useEffect(() => {
    localStorage.setItem("invitation", true);
    // dispatch(setStatusInvitation(true))
    onSubmit()
  }, [])

  return (
    <div>
      Login Succes
    </div>
  );
}

export default LoginCompletionSuccess;